export const dgmmcResultsFinals = [
   {
      name: 'Tobi Joshua',
      surname: 'Akpata',
      score: '',
      school: 'Government Secondary School',
      currentClass: 'SS3',
   },
   {
      name: 'Etinosa',
      surname: 'Efeteyan',
      score: 55,
      school: 'GDSS, Bwari',
      currentClass: 'SS3',
   },
   {
      name: 'Abdulquadri',
      surname: 'Ishola',
      score: '',
      school:
         'Federal Government Academy, Center for the Gited and Talented, Suleja',
      currentClass: 'SS3',
   },
   {
      name: 'David',
      surname: 'Aliyu',
      score: 60,
      school:
         'Federal Government Academy, Center for the Gited and Talented, Suleja',
      currentClass: 'SS3',
   },
   {
      name: 'Ogonna',
      surname: 'Onah',
      score: 40,
      school:
         'Federal Government Academy, Center for the Gited and Talented, Suleja',
      currentClass: 'SS3',
   },
   {
      name: 'Favour Mmesoma',
      surname: 'Ohuabunwa',
      score: '',
      school: 'School for the Gited, Gwagwalada',
      currentClass: 'SS3',
   },
   {
      name: 'Mukhlis',
      surname: 'Mukhtar',
      score: 60,
      school: 'School for the Gited, Gwagwalada',
      currentClass: 'SS3',
   },
   {
      name: 'Oluwatosin',
      surname: 'Bamidele',
      score: 45,
      school: 'School for the Gited, Gwagwalada',
      currentClass: 'SS3',
   },
   {
      name: 'Fadeelah',
      surname: 'Agoro',
      score: 60,
      school: 'School for the Gited, Gwagwalada',
      currentClass: 'SS3',
   },
   {
      name: 'Ojie',
      surname: 'Abhulimen',
      score: '',
      school: 'School for the Gited, Gwagwalada',
      currentClass: 'SS3',
   },
];

export const dgmmcMarchResults = [
   {
      school: 'SCHOOL FOR THE GIFTED, GWAGWALADA',
      firstName: 'Mukhtar',
      lastName: 'Mukhlis',
      gender: 'm',
      class: 'SS 2',
      score: 75,
      remark: 'q',
   },
   {
      school: 'FEDERAL GOVENMENT GIFTED ACADEMY, SULEJA',
      firstName: 'Ishola',
      lastName: 'Abdulquadri Okade',
      gender: 'm',
      class: 'SS 2',
      score: 67,
      remark: 'q',
   },
   {
      school: 'SCHOOL FOR THE GIFTED, GWAGWALADA',
      firstName: 'Ojie',
      lastName: 'Abhulimen',
      gender: 'm',
      class: 'SS 2',
      score: 63,
      remark: 'q',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, KWALI',
      firstName: 'DADA',
      lastName: 'ABDULHAFIZ',
      gender: 'm',
      class: 'SS 2',
      score: 57,
      remark: 'q',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, PEGI',
      firstName: 'VICTOR',
      lastName: 'AKOWE',
      gender: 'm',
      class: 'SS 2',
      score: 53,
      remark: 'q',
   },
   {
      school: 'GOVERNMENT  DAY   SECONDARY  SCHOOL, BWARI',
      firstName: 'ETINOSA ',
      lastName: 'EFETEYAN',
      gender: 'm',
      class: 'SS 2',
      score: 50,
      remark: 'q',
   },
   {
      school: 'GOVERNMENT  DAY   SECONDARY  SCHOOL, BWARI',
      firstName: 'JOB',
      lastName: 'GODWIN',
      gender: 'm',
      class: 'SS 2',
      score: 50,
      remark: 'q',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, MPAPE',
      firstName: 'GODSWILL',
      lastName: 'AKWARANDU',
      gender: 'm',
      class: 'SS 2',
      score: 50,
      remark: 'q',
   },
   {
      school: 'FEDERAL GOVENMENT GIFTED ACADEMY, SULEJA',
      firstName: 'David ',
      lastName: 'Aliyu',
      gender: 'm',
      class: 'SS 2',
      score: 48,
      remark: 'q',
   },
   {
      school: 'SCHOOL FOR THE GIFTED, GWAGWALADA',
      firstName: 'Oluwatosin',
      lastName: 'Bamidele',
      gender: 'm',
      class: 'SS 2',
      score: 45,
      remark: 'q',
   },
   {
      school: 'GOVT DAY SEC. SCHOOL, GWAGWALADA',
      firstName: 'Celestine',
      lastName: 'Eze',
      gender: 'm',
      class: 'SS 2',
      score: 45,
      remark: 'q',
   },
   {
      school: 'SCHOOL FOR THE GIFTED, GWAGWALADA',
      firstName: 'Fadeelah',
      lastName: 'Agoro',
      gender: 'f',
      class: 'SS 2',
      score: 43,
      remark: 'q',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, DOBI',
      firstName: 'MUSA',
      lastName: 'GENESIS',
      gender: 'm',
      class: 'SS 2',
      score: 43,
      remark: 'q',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL,  GWAGWALADA',
      firstName: 'Tobi Joshua',
      lastName: 'Akpata',
      gender: 'm',
      class: 'SS 2',
      score: 43,
      remark: 'q',
   },
   {
      school: 'GOVERNMENT  DAY   SECONDARY  SCHOOL, BWARI',
      firstName: 'JOHN ',
      lastName: 'VICTOR',
      gender: 'm',
      class: 'SS 2',
      score: 42,
      remark: 'q',
   },
   {
      school: 'FEDERAL GOVENMENT GIFTED ACADEMY, SULEJA',
      firstName: 'Onah',
      lastName: 'Ogonna Mary',
      gender: 'f',
      class: 'SS 2',
      score: 42,
      remark: 'q',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL,  GWAGWALADA',
      firstName: 'Favour',
      lastName: 'Ohuabunwa',
      gender: 'f',
      class: 'SS 2',
      score: 40,
      remark: 'q',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, DEIDEI',
      firstName: 'Godknows',
      lastName: 'Onakpa-ere',
      gender: 'm',
      class: 'SS 2',
      score: 38,
      remark: 'q',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, DEIDEI',
      firstName: 'Ebuka',
      lastName: 'Raymond',
      gender: 'm',
      class: 'SS 2',
      score: 38,
      remark: 'q',
   },
   {
      school: 'GOVERNMENT  DAY   SECONDARY  SCHOOL, BWARI',
      firstName: 'OBIA',
      lastName: 'IFEANYI',
      gender: 'm',
      class: 'SS 2',
      score: 38,
      remark: 'q',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, PEGI',
      firstName: 'Tosin',
      lastName: 'Adesigbin',
      gender: 'f',
      class: 'SS 2',
      score: 38,
      remark: 'q',
   },
   {
      school: 'GOVT SCIENCE SEC SCHOOL, TUNGAN MAJE',
      firstName: 'miracle',
      lastName: 'emelle',
      gender: 'f',
      class: 'SS 2',
      score: 38,
      remark: 'q',
   },
   {
      school: 'GOVT SECONDARY SCHOOL, ZUBA',
      firstName: 'Mohammed A',
      lastName: 'Hakeem',
      gender: 'm',
      class: 'SS 2',
      score: 37,
      remark: '',
   },
   {
      school: 'GOVT SCIENCE SEC SCHOOL TUKPECHI, KUJE',
      firstName: 'Sunday',
      lastName: 'Rosemary',
      gender: 'f',
      class: 'SS 2',
      score: 37,
      remark: '',
   },
   {
      school: 'GOVERNMENT ECONDARY SCHOOL, APO',
      firstName: 'ONYINYECHUKWU',
      lastName: 'MBAH',
      gender: 'f',
      class: 'SS 2',
      score: 36,
      remark: '',
   },
   {
      school: 'FEDERAL GOVENMENT GIFTED ACADEMY, SULEJA',
      firstName: 'Adefehinti',
      lastName: 'Ayo J.',
      gender: 'm',
      class: 'SS 2',
      score: 36,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, DEIDEI',
      firstName: 'Favour',
      lastName: 'Ani',
      gender: 'm',
      class: 'SS 2',
      score: 35,
      remark: '',
   },
   {
      school: 'GOVERNMENT  DAY   SECONDARY  SCHOOL, BWARI',
      firstName: 'POPOOLA',
      lastName: 'TIMOTHY',
      gender: 'm',
      class: 'SS 2',
      score: 35,
      remark: '',
   },
   {
      school: 'ARMY DAY SECONDARY SCHOOL, MAITAMA',
      firstName: 'Habibullah',
      lastName: 'Abdulkareem Adinoyi',
      gender: 'm',
      class: 'SS 2',
      score: 0,
      remark: 'd',
   },
   {
      school: 'GOVERNMENT DAY SECONDARY SCHOOL, WUSE II',
      firstName: 'Yahaya',
      lastName: 'Zakariya',
      gender: 'm',
      class: 'SS 2',
      score: 35,
      remark: '',
   },
   {
      school: 'SCHOOL FOR THE GIFTED, GWAGWALADA',
      firstName: 'Onyekwelu',
      lastName: 'Daniella',
      gender: 'f',
      class: 'SS 2',
      score: 35,
      remark: '',
   },
   {
      school: 'ARMY DAY SECONDARY SCHOOL, MAITAMA',
      firstName: 'Isyaku',
      lastName: 'Basiru',
      gender: 'm',
      class: 'SS 2',
      score: 33,
      remark: '',
   },
   {
      school: 'GOVT SEC. SCHOOL, KABUSA',
      firstName: 'Marvelous',
      lastName: 'Prince',
      gender: 'f',
      class: 'SS 2',
      score: 33,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, MPAPE',
      firstName: 'Vincent',
      lastName: 'Anthony',
      gender: 'm',
      class: 'SS 2',
      score: 33,
      remark: '',
   },
   {
      school: 'GOVERNMENT DAY SECONDARY SCHOOL, KARU',
      firstName: 'Adenike',
      lastName: 'Mercy Adekola',
      gender: 'f',
      class: 'SS 2',
      score: 33,
      remark: '',
   },
   {
      school: 'GOVERNMENT ECONDARY SCHOOL, APO',
      firstName: 'DANIEL',
      lastName: 'OJO',
      gender: 'm',
      class: 'SS 2',
      score: 33,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, KWALI',
      firstName: 'ALAMBA',
      lastName: 'SIMON JAMES',
      gender: 'm',
      class: 'SS 2',
      score: 33,
      remark: '',
   },
   {
      school: 'GOVT DAY SEC. SCHOOL, GWAGWALADA',
      firstName: 'Israel',
      lastName: 'Ihechikwueme',
      gender: 'm',
      class: 'SS 2',
      score: 33,
      remark: '',
   },
   {
      school: 'GOVT SCIENCE SEC SCHOOL, TUNGAN MAJE',
      firstName: ' toyin',
      lastName: 'moses',
      gender: 'f',
      class: 'SS 2',
      score: 33,
      remark: '',
   },
   {
      school: 'FEDERAL GOVENMENT GIFTED ACADEMY, SULEJA',
      firstName: 'Awe',
      lastName: 'Mercy',
      gender: 'f',
      class: 'SS 2',
      score: 33,
      remark: '',
   },
   {
      school: 'GOVERNMENT DAY SECONDARY SCHOOL, KARU',
      firstName: 'Marthias',
      lastName: 'Odama',
      gender: 'm',
      class: 'SS 2',
      score: 32,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY  SCHOOL, GARKI, AREA 10',
      firstName: 'Ajiboye ',
      lastName: 'Eniola Grace ',
      gender: 'f',
      class: 'SS 2',
      score: 32,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, AGYANA',
      firstName: 'Isah',
      lastName: 'Salamatu',
      gender: 'f',
      class: 'SS 2',
      score: 32,
      remark: '',
   },
   {
      school: 'GOVT SECONDARY SCHOOL, ZUBA',
      firstName: 'Saleh ',
      lastName: 'Ungubdo Usman',
      gender: 'm',
      class: 'SS 2',
      score: 32,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, PEGI',
      firstName: 'ISAAC',
      lastName: 'ABAH',
      gender: 'm',
      class: 'SS 2',
      score: 32,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, PAIKON-KORE',
      firstName: 'PETER',
      lastName: 'JOB',
      gender: 'm',
      class: 'SS 2',
      score: 32,
      remark: '',
   },
   {
      school: 'GOVT SCIENCE SEC SCHOOL, TUNGAN MAJE',
      firstName: 'faith',
      lastName: 'omiheaku',
      gender: 'f',
      class: 'SS 2',
      score: 32,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY  SCHOOL, KARU',
      firstName: 'JOHN',
      lastName: 'CHINEDU VICTOR',
      gender: 'm',
      class: 'SS 2',
      score: 31,
      remark: '',
   },
   {
      school: 'GOVT. SEC. SCHOOL, KUBWA',
      firstName: 'Marvellous ',
      lastName: 'Ilori',
      gender: 'm',
      class: 'SS 2',
      score: 30,
      remark: '',
   },
   {
      school: 'GOVT GILS SECONDARY SCHOOL, DUTSE',
      firstName: 'AISHAH ',
      lastName: 'SULEIMAN',
      gender: 'f',
      class: 'SS 2',
      score: 30,
      remark: '',
   },
   {
      school: 'GOVERNMENT DAY SECONDARY SCHOOL, WUSE II',
      firstName: 'Benita',
      lastName: 'Cokerson',
      gender: 'f',
      class: 'SS 2',
      score: 30,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, LUGBE',
      firstName: 'PECULIAR',
      lastName: 'TEMITOPE-OLUYEMI',
      gender: 'f',
      class: 'SS 2',
      score: 30,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, WUSE',
      firstName: 'Nathaniel',
      lastName: 'Shimayohol',
      gender: 'm',
      class: 'SS 2',
      score: 30,
      remark: '',
   },
   {
      school: 'GOVERNMENT DAY SECONDARY SCHOOL, KARU',
      firstName: 'Hope',
      lastName: 'Taiwo',
      gender: 'm',
      class: 'SS 2',
      score: 29,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY  SCHOOL, KARU',
      firstName: 'OGBONNA',
      lastName: 'VICTOR',
      gender: 'm',
      class: 'SS 2',
      score: 29,
      remark: '',
   },
   {
      school: 'GOVT. SEC. SCHOOL, KUBWA',
      firstName: 'Reliance ',
      lastName: 'Linus ',
      gender: 'f',
      class: 'SS 2',
      score: 28,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL GAWU, ABUJA',
      firstName: 'Lukman',
      lastName: 'Usman',
      gender: 'm',
      class: 'SS 2',
      score: 28,
      remark: '',
   },
   {
      school: 'GOVT GILS SECONDARY SCHOOL, DUTSE',
      firstName: 'MISTURAT',
      lastName: 'AKINYEMI',
      gender: 'f',
      class: 'SS 2',
      score: 28,
      remark: '',
   },
   {
      school: 'ARMY DAY SECONDARY SCHOOL, MAITAMA',
      firstName: 'Itodo',
      lastName: 'Joseph',
      gender: 'm',
      class: 'SS 2',
      score: 28,
      remark: '',
   },
   {
      school: 'GOVERNMENT DAY SECONDARY SCHOOL, KARU',
      firstName: 'Loveth',
      lastName: ' Gift Alade ',
      gender: 'f',
      class: 'SS 2',
      score: 28,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, KWALI',
      firstName: 'SABIT',
      lastName: 'AJOKE BARAKAT',
      gender: 'f',
      class: 'SS 2',
      score: 28,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, DOBI',
      firstName: 'STELLA',
      lastName: 'SUNDAY',
      gender: 'f',
      class: 'SS 2',
      score: 28,
      remark: '',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL,  GWAGWALADA',
      firstName: 'Badamasi',
      lastName: 'Attairu',
      gender: 'm',
      class: 'SS 2',
      score: 28,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY  SCHOOL, GARKI, AREA 10',
      firstName: 'Chisom ',
      lastName: 'Onyekwere ',
      gender: 'm',
      class: 'SS 2',
      score: 28,
      remark: '',
   },
   {
      school: 'GOVT. SEC. SCHOOL, KUBWA',
      firstName: 'Chinonso',
      lastName: 'Nwachukwu ',
      gender: 'm',
      class: 'SS 2',
      score: 27,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL GAWU, ABUJA',
      firstName: 'Abdullahi',
      lastName: 'A. Chado',
      gender: 'm',
      class: 'SS 2',
      score: 27,
      remark: '',
   },
   {
      school: 'GOVT SEC. SCHOOL, KABUSA',
      firstName: 'Sogbanmu',
      lastName: 'Esther',
      gender: 'f',
      class: 'SS 2',
      score: 27,
      remark: '',
   },
   {
      school: 'GOVT SEC. SCHOOL, KABUSA',
      firstName: 'Victor',
      lastName: 'Ademola',
      gender: 'm',
      class: 'SS 2',
      score: 27,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, GWARINPA',
      firstName: 'CHIDIMMA',
      lastName: 'OBETTA',
      gender: 'f',
      class: 'SS 2',
      score: 27,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, MPAPE',
      firstName: 'Emmanuella',
      lastName: 'Nwabueze',
      gender: 'f',
      class: 'SS 2',
      score: 27,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, GWARINPA ESTATE',
      firstName: 'Taiwo',
      lastName: 'Daniel',
      gender: 'm',
      class: 'SS 2',
      score: 27,
      remark: '',
   },
   {
      school: 'GOVERNMENT DAY SECONDARY SCHOOL, KARU',
      firstName: 'Favour',
      lastName: 'Asukwo',
      gender: 'm',
      class: 'SS 2',
      score: 27,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, YANGO',
      firstName: 'Sunday ',
      lastName: 'Emmanuel',
      gender: 'm',
      class: 'SS 2',
      score: 27,
      remark: '',
   },
   {
      school: "GOVERNMENT GIRLS' SECONDARY SCHOOL, ABAJI",
      firstName: 'FARIDAT DANLAMI',
      lastName: 'ABUBAKAR ',
      gender: 'f',
      class: 'SS 2',
      score: 27,
      remark: '',
   },
   {
      school: 'GOVT SEC. SCHOOL, PANDAGI',
      firstName: 'job',
      lastName: 'mercy',
      gender: 'f',
      class: 'SS 2',
      score: 27,
      remark: '',
   },
   {
      school: 'GOVT GIRLS SEC. SCHOOL DUKPA',
      firstName: 'Precious',
      lastName: 'Folorunsho',
      gender: 'f',
      class: 'SS 2',
      score: 27,
      remark: '',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL,  GWAGWALADA',
      firstName: 'Prosper',
      lastName: 'Onyegbule',
      gender: 'm',
      class: 'SS 2',
      score: 27,
      remark: '',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL,  GWAGWALADA',
      firstName: 'Dogara',
      lastName: 'Akila',
      gender: 'm',
      class: 'SS 2',
      score: 27,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, LUGBE',
      firstName: 'DIVINE',
      lastName: 'INYANG',
      gender: 'm',
      class: 'SS 2',
      score: 26,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY  SCHOOL, GARKI, AREA 10',
      firstName: 'Keke ',
      lastName: 'Loveth ',
      gender: 'f',
      class: 'SS 2',
      score: 26,
      remark: '',
   },
   {
      school: 'GOVT GILS SECONDARY SCHOOL, DUTSE',
      firstName: 'ESTHER OZIOMA',
      lastName: 'NWANKWO',
      gender: 'f',
      class: 'SS 2',
      score: 25,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, LUGBE',
      firstName: 'OBALOLUWA',
      lastName: 'OLANIPEKUN',
      gender: 'm',
      class: 'SS 2',
      score: 25,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, MPAPE',
      firstName: 'Sharon',
      lastName: 'Indger',
      gender: 'f',
      class: 'SS 2',
      score: 25,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, GWARINPA ESTATE',
      firstName: 'Firdausi',
      lastName: 'Ismail',
      gender: 'f',
      class: 'SS 2',
      score: 25,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, WUSE',
      firstName: 'Praise',
      lastName: 'Adebowale',
      gender: 'm',
      class: 'SS 2',
      score: 25,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, PAIKON-KORE',
      firstName: 'JENNIFER',
      lastName: 'BENJAMIN',
      gender: 'f',
      class: 'SS 2',
      score: 25,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL',
      firstName: 'IBRAHIM',
      lastName: 'WASAMA-M',
      gender: 'm',
      class: 'SS 2',
      score: 25,
      remark: '',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL, RUBOCHI',
      firstName: 'YAKUBU',
      lastName: 'REJOICE',
      gender: 'f',
      class: 'SS 2',
      score: 25,
      remark: '',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL, RUBOCHI',
      firstName: 'Benjamin',
      lastName: 'David',
      gender: 'm',
      class: 'SS 2',
      score: 25,
      remark: '',
   },
   {
      school: 'GOVT SCIENCE SEC SCHOOL TUKPECHI, KUJE',
      firstName: 'Ikechukwu ',
      lastName: 'Vincent',
      gender: 'm',
      class: 'SS 2',
      score: 25,
      remark: '',
   },
   {
      school: 'GOVERNMENT DAY SECONDARY SCHOOL, WUSE II',
      firstName: 'Cynthia Chinenye',
      lastName: 'Odoh',
      gender: 'f',
      class: 'SS 2',
      score: 24,
      remark: '',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL,  GWAGWA',
      firstName: 'Joseph',
      lastName: 'Ebiem',
      gender: 'm',
      class: 'SS 2',
      score: 23,
      remark: '',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL,  GWAGWA',
      firstName: 'Fraklin',
      lastName: 'Uchendu',
      gender: 'm',
      class: 'SS 2',
      score: 23,
      remark: '',
   },
   {
      school: 'GOVT GILS SECONDARY SCHOOL, DUTSE',
      firstName: 'OJOMA OYIBO',
      lastName: 'ABUH-UMORU',
      gender: 'f',
      class: 'SS 2',
      score: 23,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, JIWA',
      firstName: 'ABDULRAFIH',
      lastName: 'KHALID',
      gender: 'm',
      class: 'SS 2',
      score: 23,
      remark: '',
   },
   {
      school: 'ARMY DAY SECONDARY SCHOOL, MAITAMA',
      firstName: 'Joy',
      lastName: 'Danladi Musa',
      gender: 'm',
      class: 'SS 2',
      score: 23,
      remark: '',
   },
   {
      school: 'GOVT SEC. SCHOOL, KABUSA',
      firstName: 'Samuel',
      lastName: 'Oguomere',
      gender: 'm',
      class: 'SS 2',
      score: 23,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, WUSE',
      firstName: 'Ozere',
      lastName: 'Baruch',
      gender: 'm',
      class: 'SS 2',
      score: 23,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, AGYANA',
      firstName: 'Ndatsu Adamu',
      lastName: 'Idris',
      gender: 'm',
      class: 'SS 2',
      score: 23,
      remark: '',
   },
   {
      school: 'GOVT SECONDARY SCHOOL, ZUBA',
      firstName: 'Samuel ',
      lastName: 'Atinuke',
      gender: 'f',
      class: 'SS 2',
      score: 23,
      remark: '',
   },
   {
      school: 'GOVERNMENT SENIOR SECONDARY SCHOOL, DANGARA',
      firstName: 'Halima',
      lastName: 'Ismaila',
      gender: 'f',
      class: 'SS 2',
      score: 23,
      remark: '',
   },
   {
      school: 'GOVT GIRLS SEC. SCHOOL DUKPA',
      firstName: 'Success',
      lastName: 'Isinka',
      gender: 'f',
      class: 'SS 2',
      score: 23,
      remark: '',
   },
   {
      school: 'GOVT. SEC. SCHOOL, KUBWA',
      firstName: 'James ',
      lastName: 'Machebem',
      gender: 'm',
      class: 'SS 2',
      score: 22,
      remark: '',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL,  GWAGWA',
      firstName: 'Divine',
      lastName: 'Obioma',
      gender: 'm',
      class: 'SS 2',
      score: 22,
      remark: '',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL,  GWAGWA',
      firstName: 'Godswill',
      lastName: 'Joseph',
      gender: 'm',
      class: 'SS 2',
      score: 22,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, JIWA',
      firstName: 'ALIYU',
      lastName: 'IZUDEEN',
      gender: 'm',
      class: 'SS 2',
      score: 22,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY  SCHOOL, KARU',
      firstName: 'ELIAS',
      lastName: 'NMESOMA',
      gender: 'f',
      class: 'SS 2',
      score: 22,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY  SCHOOL, KARU',
      firstName: 'MUAZU',
      lastName: 'BINTA IYE',
      gender: 'f',
      class: 'SS 2',
      score: 22,
      remark: '',
   },
   {
      school: 'GOVT SECONDARY SCHOOL, ZUBA',
      firstName: 'Muhammad Nazir',
      lastName: 'Ibrahim ',
      gender: 'm',
      class: 'SS 2',
      score: 22,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, PAI',
      firstName: 'Fanes',
      lastName: 'Sumari',
      gender: 'm',
      class: 'SS 1',
      score: 22,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, PAI',
      firstName: 'Danlami',
      lastName: 'Tashilani',
      gender: 'm',
      class: 'SS 1',
      score: 22,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, PEGI',
      firstName: 'BENJAMIN',
      lastName: 'OKECHUKWU',
      gender: 'm',
      class: 'SS 2',
      score: 22,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, DOBI',
      firstName: 'ALICE',
      lastName: 'DANIEL',
      gender: 'f',
      class: 'SS 2',
      score: 22,
      remark: '',
   },
   {
      school: 'GOVT GIRLS SEC. SCHOOL DUKPA',
      firstName: 'Elizabeth',
      lastName: 'Olafioye',
      gender: 'f',
      class: 'SS 2',
      score: 22,
      remark: '',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL,  GWAGWALADA',
      firstName: 'Obi',
      lastName: 'Chioma',
      gender: 'f',
      class: 'SS 2',
      score: 22,
      remark: '',
   },
   {
      school: 'GOVT SCIENCE SEC SCHOOL TUKPECHI, KUJE',
      firstName: 'Yusuf',
      lastName: 'Abdulsalam',
      gender: 'm',
      class: 'SS 2',
      score: 22,
      remark: '',
   },
   {
      school: 'GOVT GILS SECONDARY SCHOOL, DUTSE',
      firstName: 'TRACY IFEAMAKA',
      lastName: 'ANEKWE',
      gender: 'f',
      class: 'SS 2',
      score: 20,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, MPAPE',
      firstName: 'Adeseye ',
      lastName: 'Inaolagi Ige',
      gender: 'm',
      class: 'SS 2',
      score: 20,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, GWARINPA ESTATE',
      firstName: 'Salim',
      lastName: 'Umar',
      gender: 'm',
      class: 'SS 2',
      score: 20,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, GWARINPA ESTATE',
      firstName: 'Joy ',
      lastName: 'Jirah',
      gender: 'f',
      class: 'SS 2',
      score: 20,
      remark: '',
   },
   {
      school: 'GOVERNMENT ECONDARY SCHOOL, APO',
      firstName: 'LAILA',
      lastName: 'MOHAMMED',
      gender: 'f',
      class: 'SS 2',
      score: 20,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, AGYANA',
      firstName: 'Abdulazeez',
      lastName: 'Mukail',
      gender: 'm',
      class: 'SS 2',
      score: 20,
      remark: '',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL,  GWAGWALADA',
      firstName: 'Obinna',
      lastName: 'Ozioko',
      gender: 'm',
      class: 'SS 2',
      score: 20,
      remark: '',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL, RUBOCHI',
      firstName: 'ABRAHAM',
      lastName: 'OBED',
      gender: 'm',
      class: 'SS 2',
      score: 20,
      remark: '',
   },
   {
      school: 'GOVT SCIENCE SEC SCHOOL TUKPECHI, KUJE',
      firstName: 'Olaoluwa',
      lastName: 'Michael',
      gender: 'm',
      class: 'SS 2',
      score: 20,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL GAWU, ABUJA',
      firstName: 'Nazira',
      lastName: 'Ibrahim',
      gender: 'f',
      class: 'SS 2',
      score: 18,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL GAWU, ABUJA',
      firstName: 'Fauzan',
      lastName: 'Kusodo Muhammad',
      gender: 'm',
      class: 'SS 2',
      score: 18,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, LUGBE',
      firstName: 'ABOSEDE',
      lastName: 'OLABAMIJI',
      gender: 'f',
      class: 'SS 2',
      score: 18,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, AGYANA',
      firstName: 'Peter',
      lastName: 'Paul',
      gender: 'm',
      class: 'SS 2',
      score: 18,
      remark: '',
   },
   {
      school: 'GOVT SECONDARY SCHOOL, ZUBA',
      firstName: 'Hauwlat Onize',
      lastName: 'Ibrahim ',
      gender: 'f',
      class: 'SS 2',
      score: 18,
      remark: '',
   },
   {
      school: 'GOVERNMENT SENIOR SECONDARY SCHOOL, DANGARA',
      firstName: 'Divine',
      lastName: 'Arojuoga',
      gender: 'm',
      class: 'SS 2',
      score: 18,
      remark: '',
   },
   {
      school: 'GOVERNMENT SENIOR SECONDARY SCHOOL, DANGARA',
      firstName: 'Moses',
      lastName: 'Sani',
      gender: 'm',
      class: 'SS 2',
      score: 18,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, PEGI',
      firstName: 'DAVID ',
      lastName: 'ONYEUKWU',
      gender: 'm',
      class: 'SS 2',
      score: 18,
      remark: '',
   },
   {
      school: "GOVERNMENT GIRLS' SECONDARY SCHOOL, ABAJI",
      firstName: 'PRECIOUS A.',
      lastName: 'OLAJIDE',
      gender: 'f',
      class: 'SS 2',
      score: 18,
      remark: '',
   },
   {
      school: 'GOVT SEC. SCHOOL, PANDAGI',
      firstName: 'samuel ',
      lastName: 'sunday',
      gender: 'm',
      class: 'SS 2',
      score: 18,
      remark: '',
   },
   {
      school: 'GOVT DAY SEC. SCHOOL, GWAGWALADA',
      firstName: 'Maryqueen',
      lastName: 'Osheidu',
      gender: 'f',
      class: 'SS 2',
      score: 18,
      remark: '',
   },
   {
      school: 'GOVT SCIENCE SEC SCHOOL TUKPECHI, KUJE',
      firstName: 'Umar',
      lastName: 'Nafisat',
      gender: 'f',
      class: 'SS 2',
      score: 18,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, DEIDEI',
      firstName: 'Victor',
      lastName: 'Michael',
      gender: 'm',
      class: 'SS 2',
      score: 17,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, DEIDEI',
      firstName: 'Abdulwahab',
      lastName: 'Isah',
      gender: 'm',
      class: 'SS 2',
      score: 17,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL GAWU, ABUJA',
      firstName: 'Solomon',
      lastName: 'T. John',
      gender: 'm',
      class: 'SS 2',
      score: 17,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, JIWA',
      firstName: 'CHIDERA',
      lastName: 'ABONYI',
      gender: 'm',
      class: 'SS 2',
      score: 17,
      remark: '',
   },
   {
      school: 'GOVT SEC. SCHOOL, KABUSA',
      firstName: 'Edwin',
      lastName: 'David',
      gender: 'm',
      class: 'SS 2',
      score: 17,
      remark: '',
   },
   {
      school: 'GOVERNMENT DAY SECONDARY SCHOOL, WUSE II',
      firstName: 'Umar Yanda',
      lastName: 'Abdurrahman',
      gender: 'm',
      class: 'SS 2',
      score: 17,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, LUGBE',
      firstName: 'ONORUOIZA',
      lastName: 'SUNDAY',
      gender: 'm',
      class: 'SS 2',
      score: 17,
      remark: '',
   },
   {
      school: 'GOVERNMENT ECONDARY SCHOOL, APO',
      firstName: 'MIRACLE',
      lastName: 'ALAKWE',
      gender: 'm',
      class: 'SS 2',
      score: 17,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, KWALI',
      firstName: 'ABDULRAHMAN',
      lastName: 'NAFISAT KADIR',
      gender: 'f',
      class: 'SS 2',
      score: 17,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, YANGO',
      firstName: 'SAMUEL',
      lastName: 'ELIJAH',
      gender: 'm',
      class: 'SS 2',
      score: 17,
      remark: '',
   },
   {
      school: 'GOVERNMENT SENIOR SECONDARY SCHOOL, DANGARA',
      firstName: 'Heritage',
      lastName: 'Oladapo ',
      gender: 'm',
      class: 'SS 2',
      score: 17,
      remark: '',
   },
   {
      school: 'GOVERNMENT SENIOR SECONDARY SCHOOL, DANGARA',
      firstName: 'Precious',
      lastName: 'Uzonwanne',
      gender: 'm',
      class: 'SS 2',
      score: 17,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, PAI',
      firstName: 'Sunday',
      lastName: 'Samuel',
      gender: 'm',
      class: 'SS 1',
      score: 17,
      remark: '',
   },
   {
      school: "GOVERNMENT GIRLS' SECONDARY SCHOOL, ABAJI",
      firstName: 'BINAH ULARAMAI',
      lastName: 'ALEX',
      gender: 'f',
      class: 'SS 2',
      score: 17,
      remark: '',
   },
   {
      school: 'GOVT DAY SEC. SCHOOL, GWAGWALADA',
      firstName: 'Mary',
      lastName: 'Matthew',
      gender: 'f',
      class: 'SS 2',
      score: 17,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, DOBI',
      firstName: 'JERRY',
      lastName: 'JAPHET',
      gender: 'm',
      class: 'SS 2',
      score: 17,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, PAIKON-KORE',
      firstName: 'BENICY',
      lastName: 'AMEH',
      gender: 'f',
      class: 'SS 2',
      score: 17,
      remark: '',
   },
   {
      school: 'GOVT GIRLS SEC. SCHOOL DUKPA',
      firstName: 'Anadoo',
      lastName: 'Buruku',
      gender: 'f',
      class: 'SS 2',
      score: 17,
      remark: '',
   },
   {
      school: "GOVERNMENT GIRLS' SECONDARY SCHOOL, ABAJI",
      firstName: 'ZAINAB',
      lastName: 'ABUBAKAR',
      gender: 'f',
      class: 'SS 2',
      score: 16,
      remark: '',
   },
   {
      school: 'GOVT. SEC. SCHOOL, KUBWA',
      firstName: 'Paula',
      lastName: 'Onuoha',
      gender: 'f',
      class: 'SS 1',
      score: 15,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, GWARINPA',
      firstName: 'EMMANUEL ',
      lastName: 'ADEKOLA',
      gender: 'm',
      class: 'SS 2',
      score: 15,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, WUSE',
      firstName: 'Chisom ',
      lastName: 'Ike',
      gender: 'm',
      class: 'SS 2',
      score: 15,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY  SCHOOL, GARKI, AREA 10',
      firstName: 'Nsirim ',
      lastName: 'Rabbai C ',
      gender: 'm',
      class: 'SS 2',
      score: 15,
      remark: '',
   },
   {
      school: 'GOVERNMENT ECONDARY SCHOOL, APO',
      firstName: 'SHERIFAT',
      lastName: 'MOMOH',
      gender: 'f',
      class: 'SS 2',
      score: 15,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, KWALI',
      firstName: 'ALAMBA',
      lastName: ' SIMON JOHN',
      gender: 'm',
      class: 'SS 2',
      score: 15,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, YANGO',
      firstName: 'Tauheed ',
      lastName: 'Yusuf Alabo',
      gender: 'm',
      class: 'SS 2',
      score: 15,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, PAI',
      firstName: 'Chiemerie Lamuel',
      lastName: 'Nwokoro',
      gender: 'm',
      class: 'SS 2',
      score: 15,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, PAI',
      firstName: 'Nehemiah F.',
      lastName: 'Amos',
      gender: 'm',
      class: 'SS 2',
      score: 15,
      remark: '',
   },
   {
      school: "GOVERNMENT GIRLS' SECONDARY SCHOOL, ABAJI",
      firstName: 'MARYAM',
      lastName: 'IBRAHIM',
      gender: 'f',
      class: 'SS 2',
      score: 15,
      remark: '',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL,  GWAGWA',
      firstName: 'Rejoice',
      lastName: 'Philemon',
      gender: 'm',
      class: 'SS 2',
      score: 13,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, YANGO',
      firstName: 'Abubakar ',
      lastName: 'Hamza',
      gender: 'm',
      class: 'SS 2',
      score: 13,
      remark: '',
   },
   {
      school: 'GOVT DAY SEC. SCHOOL, GWAGWALADA',
      firstName: 'Israel',
      lastName: 'Oluwafemi',
      gender: 'm',
      class: 'SS 2',
      score: 13,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, PAIKON-KORE',
      firstName: 'JESSICA',
      lastName: 'MARKUS',
      gender: 'f',
      class: 'SS 2',
      score: 13,
      remark: '',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL, RUBOCHI',
      firstName: 'YUNANA',
      lastName: 'EPHRAIM',
      gender: 'm',
      class: 'SS 2',
      score: 13,
      remark: '',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL, RUBOCHI',
      firstName: 'BAKO',
      lastName: 'PATIENCE',
      gender: 'f',
      class: 'SS 2',
      score: 13,
      remark: '',
   },
   {
      school: 'GOVT SCIENCE SEC SCHOOL, TUNGAN MAJE',
      firstName: 'Abdulrazaq',
      lastName: 'Umar Halidu',
      gender: 'm',
      class: 'SS 2',
      score: 13,
      remark: '',
   },
   {
      school: 'ARMY DAY SECONDARY SCHOOL, MAITAMA',
      firstName: 'Abubakar',
      lastName: 'Garba Maikanti',
      gender: 'm',
      class: 'SS 1',
      score: 13,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, GWARINPA ESTATE',
      firstName: 'Favour',
      lastName: 'Raphael',
      gender: 'f',
      class: 'SS 2',
      score: 12,
      remark: '',
   },
   {
      school: 'GOVT GIRLS SEC. SCHOOL DUKPA',
      firstName: 'Fatima',
      lastName: 'Isah Abubakar',
      gender: 'f',
      class: 'SS 2',
      score: 12,
      remark: '',
   },
   {
      school: 'GOVERNMENT DAY SECONDARY SCHOOL, WUSE II',
      firstName: 'Ayisha',
      lastName: 'Abdulrahim',
      gender: 'f',
      class: 'SS 2',
      score: 10,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY  SCHOOL, GARKI, AREA 10',
      firstName: 'Ojeh ',
      lastName: 'Favour Chinedu',
      gender: 'm',
      class: 'SS 2',
      score: 10,
      remark: '',
   },
   {
      school: 'GOVT SEC. SCHOOL, PANDAGI',
      firstName: 'makir',
      lastName: 'donald',
      gender: 'm',
      class: 'SS 2',
      score: 8,
      remark: '',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, YANGO',
      firstName: 'Ugwu ',
      lastName: 'Charles',
      gender: 'm',
      class: 'SS 2',
      score: 7,
      remark: '',
   },
   {
      school: 'GOVERNMENT  SECONDARY  SCHOOL,  GWAGWA',
      firstName: 'Justin',
      lastName: 'Anekunu',
      gender: 'm',
      class: 'SS 2',
      score: 0,
      remark: 'a',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, JIWA',
      firstName: 'IBRAHIM',
      lastName: 'NDACEKO',
      gender: 'm',
      class: 'SS 2',
      score: 0,
      remark: 'd',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, JIWA',
      firstName: 'FELICIA',
      lastName: 'BART-IWODI',
      gender: 'f',
      class: 'SS 2',
      score: 0,
      remark: 'd',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, GWARINPA',
      firstName: 'DENNIS',
      lastName: 'OZIEGBE',
      gender: 'm',
      class: 'SS 2',
      score: 0,
      remark: 'a',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, GWARINPA',
      firstName: 'OLATODUN OPEYEMI',
      lastName: 'OKEOWO',
      gender: 'm',
      class: 'SS 2',
      score: 0,
      remark: 'd',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, GWARINPA',
      firstName: 'GIDEON',
      lastName: 'TIMOTHY OCHOYODA',
      gender: 'm',
      class: 'SS 2',
      score: 0,
      remark: 'd',
   },
   {
      school: 'GOVERNMENT DAY SECONDARY SCHOOL, WUSE II',
      firstName: 'Yahaya',
      lastName: 'Zakariya',
      gender: 'm',
      class: 'SS 2',
      score: 0,
      remark: 'a',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, GWARINPA ESTATE',
      firstName: 'Salim',
      lastName: 'Umar',
      gender: 'm',
      class: 'SS 2',
      score: 0,
      remark: 'a',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, WUSE',
      firstName: 'Arab',
      lastName: 'Aisha Muhammed',
      gender: 'f',
      class: 'SS 2',
      score: 0,
      remark: 'd',
   },
   {
      school: 'GOVERNMENT SECONDARY  SCHOOL, KARU',
      firstName: 'TESTIMONY',
      lastName: 'ODEY',
      gender: 'f',
      class: 'SS 2',
      score: 0,
      remark: 'a',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, AGYANA',
      firstName: 'Yunusa',
      lastName: "Naja'atu",
      gender: 'f',
      class: 'SS 2',
      score: 0,
      remark: 'a',
   },
   {
      school: 'GOVT SEC. SCHOOL, PANDAGI',
      firstName: 'chado',
      lastName: 'Abdulmutallib',
      gender: 'm',
      class: 'SS 2',
      score: 0,
      remark: 'a',
   },
   {
      school: 'GOVT SEC. SCHOOL, PANDAGI',
      firstName: 'Augustine ',
      lastName: 'Isaac',
      gender: 'm',
      class: 'SS 2',
      score: 0,
      remark: 'a',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, DOBI',
      firstName: 'PETER',
      lastName: 'ETTE',
      gender: 'm',
      class: 'SS 2',
      score: 0,
      remark: 'a',
   },
   {
      school: 'GOVERNMENT SECONDARY SCHOOL, PAIKON-KORE',
      firstName: 'PETER',
      lastName: 'JOB',
      gender: 'm',
      class: 'SS 2',
      score: 0,
      remark: 'a',
   },
];
